import React, { ReactNode } from 'react';

export interface INoRedirectingLinkProps {
	children: ReactNode;
	onClick: () => void;
}

const NoRedirectingLink = (props: INoRedirectingLinkProps) => (
	<div
		style={{ textDecoration: 'none', color: '#1045FF', fontWeight: 500, cursor: 'pointer' }}
		className='MuiTypography-root MuiLink-root MuiLink-underlineHover MuiTypography-colorPrimary'
		onClick={props.onClick}
	>
		{props.children}
	</div>
);

export default NoRedirectingLink;
